import httpInstance from '../httpInstance';

const createCategoriesPaymentService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/beneficiary-catalog';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createCategoriesPaymentService;
